import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as mapboxgl from 'mapbox-gl';
import { take } from 'rxjs/operators';
import { DataTrack } from 'src/app/model/dataTrack.model';
import { RoundInfoResponse } from 'src/app/model/round-info-response.model';
import { AtInternetService } from 'src/app/services/at-internet.service';
import { TrackingParcelRoutingService } from 'src/app/services/tracking-parcel-routing.service';
import { environment } from 'src/environments/environment.prod';
declare let TFT;
declare let TFE;

@Component({
  selector: 'app-delivery-map',
  templateUrl: './delivery-map.component.html',
  styleUrls: ['./delivery-map.component.scss'],
})
export class DeliveryMapComponent implements OnInit {
  tag;
  openTime: number;
  cab: string;
  titleMap: string="Votre colis est en cours de livraison";
  deliveryAdresse: string='';
  data: RoundInfoResponse;
  minLeft: number=0;
  responseTpr: any;
  //mapbox gl
  map: mapboxgl.Map;
  urlTpr: string;
  accessToken:string;
  accountNum: string;
  isTousFacteurAccounts: boolean=false;
  constructor(
    public dialogRef: MatDialogRef<DeliveryMapComponent>,
    @Inject(MAT_DIALOG_DATA) public injectedData,
    private atInternetService: AtInternetService,
    public trackingParcelRoutingService: TrackingParcelRoutingService) { }
    
  ngOnInit(): void {
    this.urlTpr='';
    this.accessToken=environment.mapbox.accessToken ;
    let data = new DataTrack();
    this.tag = this.injectedData.tag;
    this.cab = this.injectedData.cab;
    this.responseTpr = this.injectedData.responseTpr;
    this.openTime = this.injectedData.openTime;
    this.accountNum = this.injectedData.shipperId;
    if (this.injectedData.deliveryAdresse.trim() !== '') {
      this.deliveryAdresse = " : " + this.injectedData.deliveryAdresse;
    }
    //SQUAD4-5458 : Retour arrière sur la mise en place de TOUSFACTEURS
   //this.checkTousFacteurAccounts();
   this.data = this.responseTpr;
   //SQUAD4-5458 : Retour arrière sur la mise en place de TOUSFACTEURS
    /*if (this.responseTpr && this.isTousFacteurAccounts) {
          if (this.responseTpr.status[0].code === "0"){
          // set data
          let currentDelivery = this.responseTpr.currentDelivery;
          data.currentDelivery = {isInTransit: true, latitude: currentDelivery.latitude, longitude: currentDelivery.longitude};

          let pastDeliveries = new Array();
          this.responseTpr.round.forEach(element => {
            let timeStamp = element.eventDate;
            let pastDelivery = {
              latitude: element.latitude,
              longitude: element.longitude,
              timestamp: timeStamp,
            }
            pastDeliveries.push(pastDelivery);
          });

          data.pastDeliveries = pastDeliveries;
          data.roundId = this.responseTpr.roundId;
          this.trackingParcelRoutingService.getApiKeyTrackEngage().subscribe(
            res => {
              TFT.init({
                map: {
                  apikey: res,
                  provider: 'here'
                },
                clientCode: this.injectedData.shipperId,
                data: data,
                host: "https://colissimo.proxipick.com/",
                target: "#map-container-tft",
                alignMarkersInWayline : true,
              });
              TFE.init({
                clientCode: this.injectedData.shipperId,
                host: "https://colissimo.proxipick.com/",
                target: "#map-container-tft",
              });
          });
        }else {
          this.showErrorPopup();
        }
      } */

    if (!this.isTousFacteurAccounts) {
        if (this.data && this.data.status[0].code=== "0") {
          let pastDeliveries = new Array();
          this.data.round.forEach(element => {
            let pastDelivery = {
              latitude: element.latitude,
              longitude: element.longitude,
              timestamp: element.eventPassedMinutes,
            }
            pastDeliveries.push(pastDelivery);
          });

          //sorting by last position timestamp for mapbox
          pastDeliveries=pastDeliveries.sort((b,a) => b.timestamp - a.timestamp);
          if (this.data.currentDelivery && this.data.currentDelivery.longitude && this.data.currentDelivery.latitude){
            this.minLeft=Math.abs(pastDeliveries[0].timestamp);
          }
        }
      }
  }
  showErrorPopup() {
     document.getElementById("error-msg").innerHTML = "Le service de localisation est actuellement indisponible. Nous vous invitons à réessayer ultérieurement.";
      document.getElementById('error-msg').style.display = 'block'; // Display error message
  }
  onNoClick(): void {
    let timeSpent = (Date.now() - this.openTime);
    this.atInternetService.generateClickCloseMap(
      this.tag,
      'CTA_fermeture_carte',
      'popin_Cartographie',
      timeSpent,
      this.cab
    );
    this.dialogRef.close();
  }
  //SQUAD4-5458 : Retour arrière sur la mise en place de TOUSFACTEURS
  /*checkTousFacteurAccounts(): void {
  this.trackingParcelRoutingService.getCdiscountAccounts().subscribe(
    response => {
      if(response) {
        if (this.accountNum && response.includes(this.accountNum)) {
          this.isTousFacteurAccounts=true;
        }
      }
  });
} */

}
